import { OrderFailureReason } from '../../constants/order';
import { BackendError } from './base';
import General from './general';

class AddressDoesNotExist extends General.NotFound {}
class CardAlreadyExists extends BackendError {}
class CardDoesNotExist extends General.NotFound {}
class CardIsInvalid extends BackendError {}
class CouldNotCreateCard extends BackendError {}
class CouldNotUpdateCard extends BackendError {}

type CreditCardResponse = {
    failureReason: OrderFailureReason;
};

class CreditCardRefused extends BackendError {
    public readonly failureReason: OrderFailureReason;

    constructor(
        public message = 'Your credit card was refused.',
        public code?: number | string,
        public url?: string,
        public response?: unknown
    ) {
        super(message);
        this.failureReason =
            (response as CreditCardResponse)?.failureReason ?? 'unknown';
    }
}

export default {
    AddressDoesNotExist,
    CardAlreadyExists,
    CardDoesNotExist,
    CardIsInvalid,
    CouldNotCreateCard,
    CouldNotUpdateCard,
    CreditCardRefused,
};
export type { CreditCardRefused };
